import React from "react";
import { LoadingSpinner, Modal, } from "@catchoftheday/cg-components";
export const OnePassModal = ({ children, loading, ...props }) => {
    return (<Modal sizeVariant="medium" height={{ sm: "auto" }} borderRadius="corner" closeButtonProps={{
            bg: "onePass.primaryDarker",
            width: "36px",
            height: "36px",
        }} closeIconProps={{ width: "16px", height: "16px" }} contentProps={{
            height: "auto",
        }} enableDefaultResponsiveStyles={false} maxHeight="90%" {...props}>
      {loading && (<LoadingSpinner containerProps={{ "aria-label": "loading spinner", zIndex: 1 }} hasOverlay ringBg="ui.borderColor"/>)}
      {children}
    </Modal>);
};
